export function getIndex(sessionStorage, stories){
  const index = parseInt(sessionStorage.getItem('slideIndex') || 0)
  if(index >= stories.length) return 0

  return index
}
